<template>
    <main class="relative isolate">
        <div
            class="relative isolate mx-auto max-w-7xl overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0"
        >
            <div
                class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10"
            >
                <div
                    class="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8"
                >
                    <div class="lg:pr-4">
                        <div class="lg:max-w-lg">
                            <p class="text-base font-semibold leading-7 text-lime-600">Alles was Sie brauchen</p>
                            <h1 class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                                Der E-Rollstuhl
                            </h1>
                            <p class="mt-6 text-xl leading-8 text-gray-700">
                                Ein Begleiter in allen Lebenslagen. Der Unterstützer, welcher Sie auch mit
                                Einschränkungen mobil und flexibel hält und zum täglichen Helfer wird.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    class="-ml-12 -mt-12 flex flex-col items-center p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden"
                >
                    <img
                        class="sticky top-0 mx-auto w-[22rem] max-w-none mix-blend-multiply sm:w-[32rem]"
                        src="/img/wheelchair/eroller.jpg"
                        alt=""
                    />
                </div>
                <div
                    class="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8"
                >
                    <div class="lg:pr-4">
                        <div class="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
                            <ul role="list" class="mt-2 space-y-8 text-gray-600">
                                <li v-for="benefit in benefits" :key="benefit.title" class="flex gap-x-3">
                                    <component
                                        :is="benefit.icon"
                                        class="mt-1 h-5 w-5 flex-none text-lime-600"
                                        aria-hidden="true"
                                    />
                                    <span
                                        ><strong class="font-semibold text-gray-900">{{ benefit.title }}: </strong
                                        >{{ benefit.description }}</span
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import {
    Battery100Icon,
    ShieldExclamationIcon,
    BoltIcon,
    ShoppingBagIcon,
    PlusCircleIcon,
    ChevronDoubleRightIcon,
} from '@heroicons/vue/24/outline'

const benefits = [
    {
        icon: Battery100Icon,
        title: 'Maximale Reichweite',
        description:
            'Damit Sie mobil bleiben und sich flexibel fortbewegen können, ist eine gute Akkuleistung essenziell.',
    },
    {
        icon: ShieldExclamationIcon,
        title: 'Höchste Sicherheitsstandards',
        description:
            'Als ständiger Begleiter entspricht der E-Rollstuhl natürlich allen Sicherheitsrichtlinien. Außerdem sind durch die Ausstattung auch persönliche Habseligkeiten sicher verstaubar.',
    },
    {
        icon: BoltIcon,
        title: 'Hohe Belastbarkeit',
        description:
            'Für die freie Bewegung, selbst auf Reisen, ist eine hohe Widerstandsfähigkeit besonders von Vorteil.  Auf den E-Rolli können Sie sich in jeder Lage verlassen.',
    },
    {
        icon: ShoppingBagIcon,
        title: 'Optimale Mitnahmemöglichkeiten',
        description:
            'Der Rollstuhl ist komplett faltbar durch verstellbare Rücken- und Armlehnen sowie eine nach hinten einklappbare Fußstütze. Dementsprechend ist er der perfekte Reisebegleiter im Auto sowie auf dem Flug.',
    },
    {
        icon: PlusCircleIcon,
        title: 'Vielseitiges Zubehör',
        description:
            'Jede Person hat verschiedene Bedürfnisse und Nutzen eines Rollstuhls, deshalb ist es umso wichtiger, diesen individuell anpassen zu können. Von einer flexiblen Steuerung bis hin zur Reisetasche ist alles möglich.',
    },
    {
        icon: ChevronDoubleRightIcon,
        title: '2 in 1 Rollstuhl',
        description:
            'Der E-Rolli kann durch seine Akkus nicht nur elektrisch gefahren werden, sondern durch leichtes Umschalten auch als manueller Rollstuhl geschoben werden.',
    },
]
</script>
